import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-document-sign-base',
  templateUrl: './document-sign-base.component.html',
  styleUrls: ['./document-sign-base.component.css']
})
export class DocumentSignBaseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
